<template>
  <div class="dashboard-indicadores">
    <div class="dashboard-indicadores__content-wrapper">
      <div class="dashboard-indicadores__title">
        <slot name="dashboard-title"></slot>
      </div>

      <div class="dashboard-indicadores__content">
        <div class="dashboard-indicadores__content-top">
          <slot name="content-top"></slot>
        </div>

        <div class="dashboard-indicadores__content-middle">
          <slot name="content-middle"></slot>
        </div>

        <div class="dashboard-indicadores__content-bottom">
          <slot name="content-bottom"></slot>
        </div>
      </div>

      <div class="dashboard-indicadores__footer">
        <slot name="dashboard-footer"></slot>
      </div>
    </div>

    <div class="dashboard-indicadores__additional-info">
      <slot name="additional-info"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'dashboard-indicadores',
};
</script>

<style lang="scss" scoped>
.dashboard-indicadores__content-wrapper {
  border: 1px solid #73B7AE;
  border-radius: 8px;
  overflow: hidden;
  .dashboard-indicadores__title {
    color: $white;
    font-size: 1.125rem;
    font-weight: 600;
    background-color: #0F9D8A;
    padding: .5625rem 1rem;
  }
  .dashboard-indicadores__footer {
    border-top: 1px solid #73B7AE;
    font-size: .875rem;
  }
  .dashboard-indicadores__actions {
    padding: 1rem;
  }
}
.dashboard-indicadores__additional-info {
  color: #707070;
  font-size: .875rem;
  text-align: right;
  padding: .25rem .625rem;
}

@include media-breakpoint-up(lg) {
  .dashboard-indicadores {
    .dashboard-indicadores__title {
      font-size: 1.5rem;
      padding: .75rem 2.25rem;
    }
    .dashboard-indicadores__footer {
      font-size: 1rem;
    }
  }
}
</style>
